const SET_GROUP = 'SET_GROUP';
const SET_PURPOSE = 'SET_PURPOSE';
const SET_PAGE = 'SET_PAGE';
export const CLEAR_NAVIGATION_SELECTION = 'CLEAR_NAVIGATION_SELECTION';

const INITIAL_STATE = {
  group: {},
  purpose: {},
  page: {},
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_GROUP:
      return {
        group: { ...action.payload },
        purpose: {},
        page: {},
      };
    case SET_PURPOSE:
      return {
        ...state,
        purpose: { sectionId: null, sectionName: action.payload },
        page: {},
      };
    case SET_PAGE:
      return {
        ...state,
        purpose: {
          ...state.purpose,
          sectionId: action.payload.section.sectionId,
        },
        page: { ...action.payload },
      };
    case CLEAR_NAVIGATION_SELECTION:
      return INITIAL_STATE;
    default:
      return state;
  }
}

export function setGroup(group) {
  return { type: SET_GROUP, payload: group };
}

export function setPurpose(purpose) {
  return { type: SET_PURPOSE, payload: purpose };
}

export function setPage(page) {
  return { type: SET_PAGE, payload: page };
}
